import { ref } from 'vue'
import { CustomizeStep } from '../types'
import { useWindow } from './use-window'

export const useStep = () => {
  const { specList, addonList } = useWindow()

  const maxStep = ref<CustomizeStep>(CustomizeStep.ChooseProductSpec)

  const setMaxStep = (val: CustomizeStep) => {
    if (val >= maxStep.value) {
      maxStep.value = val
    }
  }

  const getStepNum = (currentStep: CustomizeStep): any => {
    const specNum = specList.length > 0 ? 1 : 0
    const addonNum = addonList.length > 0 ? 1 : 0
    switch (currentStep) {
      case CustomizeStep.ChooseProductSpec:
        return 1
      case CustomizeStep.ChooseSpec:
        return 2
      case CustomizeStep.ChooseAddon:
        return specNum + 2
      case CustomizeStep.ChooseImprint:
        return specNum + addonNum + 2
      case CustomizeStep.ChooseProducttiomTime:
        return specNum + addonNum  + 3
    }
  }

  return {
    setMaxStep,
    getStepNum
    // goNext
  }
}
